import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const CompanyDiv = styled("div")`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const DetalhesIconDiv = styled("div")`
  color: #ffbb00;
  width: 80px;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0.5px 4px;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #ffbb00;
  border-radius: 2px;
  cursor: pointer;
`;

export const CompanyForm = styled("form")`
  align-items: center;
`;

type CompanyFormControlProps = {
  percentage?: string;
};

export const CompanyFormControl = styled(FormControl)<CompanyFormControlProps>`
  width: ${(props) => (props.percentage ? props.percentage : "100%")};
  padding-right: 10px;
`;

export const CompanyInputLabel = styled(InputLabel)`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #717171;
  cursor: pointer;
`;

export const CompanyInputLabelColor = styled(InputLabel)`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #717171;
`;

export const CompanyColorDivLabel = styled("div")`
  text-align: center;
`;

export const CompanyOutlinedInput = styled(OutlinedInput)`
  background-color: #ffffff;
  border-radius: 6px;
`;

export const CompanyOutlinedInputFile = styled(OutlinedInput)`
  background-color: #ffffff;
  border-radius: 6px;
  display: none;
`;

export const CompanyColorInput = styled("input")`
  border-radius: 6px;
  width: 50px;
  height: 50px;
  padding: 0;
  border: none;
  outline: none;
  cursor: pointer;
`;

export const CompanyColorDiv = styled("div")<CompanyFormControlProps>`
  width: ${(props) => (props.percentage ? props.percentage : "100%")};
  height: 100px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 6px;
  margin-right: 10px;
`;

export const CompanySelect = styled(Select)`
  background-color: #ffffff;
  border-radius: 6px;
`;

export const CompanyMenuItem = styled(MenuItem)`
  background-color: #ffffff;
`;

export const CompanyContentButton = styled("div")`
  display: flex;
  justify-content: center;
  padding-top: 20px;
  width: 400px;
`;

export const CompanyButton = styled("button")`
  border: none;
  margin-top: 15px;
  width: 100%;
  background: #ffbb00;
  border-top: 15px solid #ffbb00;
  border-bottom: 15px solid #ffbb00;
  border-radius: 6px;
  background-color: #ffbb00;
  box-shadow: rgba(50, 50, 93, 0.1) 0px 4px 6px 0px,
    rgba(0, 0, 0, 0.08) 0px 1px 3px 0px;
  border-radius: 6px;
  cursor: pointer;

  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  color: #1f1f1f;
  &:disabled {
    background-color: #ffbb00;
    border-top: 15px solid #ffbb00;
    border-bottom: 15px solid #ffbb00;
    cursor: not-allowed;
  }
  &:hover {
    background-color: #b68500;
    border-top: 15px solid #b68500;
    border-bottom: 15px solid #b68500;
  }
`;

export const UploadTermoButton = styled("button")`
  border: none;
  margin-top: 15px;
  padding-inline: 10px;
  width: 100%;
  background: #ffe600;
  border-top: 15px solid #ffe600;
  border-bottom: 15px solid #ffe600;
  border-radius: 6px;
  background-color: #ffe600;
  box-shadow: rgba(50, 50, 93, 0.1) 0px 4px 6px 0px,
    rgba(0, 0, 0, 0.08) 0px 1px 3px 0px;
  border-radius: 6px;
  cursor: pointer;

  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  color: #1f1f1f;
  &:disabled {
    background-color: #ffbb00;
    border-top: 15px solid #ffbb00;
    border-bottom: 15px solid #ffbb00;
    cursor: not-allowed;
  }
  &:hover {
    background-color: #b68500;
    border-top: 15px solid #b68500;
    border-bottom: 15px solid #b68500;
  }
`;

export const CompanySpaceDiv = styled("div")`
  display: flex;
`;

export const ProgramCompanyGradeDiv = styled("div")`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 10px;
`;

type ProgramButtonGradeProps = {
  isSelected: boolean;
};

export const ProgramButtonGrade = styled("button")<ProgramButtonGradeProps>`
  border: none;
  margin-top: 15px;
  width: 100%;
  background: #ffffff;
  border: 15px solid #ffffff;
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: rgba(50, 50, 93, 0.1) 0px 4px 6px 0px,
    rgba(0, 0, 0, 0.08) 0px 1px 3px 0px;
  border-radius: 6px;
  cursor: pointer;

  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  color: #1f1f1f;
  &:hover {
    background-color: #0084ff;
    border: 15px solid #0084ff;
  }
  background-color: ${(props) => (props.isSelected ? "#7bff00" : "#ffffff")};
  border: 15px solid ${(props) => (props.isSelected ? "#7bff00" : "#ffffff")};
`;

export const CompanyBaseboardEndDiv = styled("div")`
  display: flex;
  justify-content: flex-end;
`;

export const CompanyAtiveButton = styled("button")`
  border: none;
  margin-top: 15px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #52ff30;
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: rgba(50, 50, 93, 0.1) 0px 4px 6px 0px,
    rgba(0, 0, 0, 0.08) 0px 1px 3px 0px;
  border-radius: 6px;
  cursor: pointer;

  margin-right: 10px;

  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  color: #1f1f1f;
  &:disabled {
    cursor: not-allowed;
  }
  &:hover {
    background-color: #52ff30;
    border-top: 15px solid #52ff30;
    border-bottom: 15px solid #52ff30;
  }
`;

export const CompanyInativeButton = styled("button")`
  border: none;
  margin-top: 15px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #ff3b30;
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: rgba(50, 50, 93, 0.1) 0px 4px 6px 0px,
    rgba(0, 0, 0, 0.08) 0px 1px 3px 0px;
  border-radius: 6px;
  cursor: pointer;

  margin-right: 10px;

  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  color: #1f1f1f;
  &:disabled {
    cursor: not-allowed;
  }
  &:hover {
    background-color: #ff3b30;
    border-top: 15px solid #ff3b30;
    border-bottom: 15px solid #ff3b30;
  }
`;

export const CompanyColorTriDiv = styled("div")`
  display: flex;
  background-color: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 6px;
`;
